import React from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import Logo from "../logo/Logo";
import "./styles.styl";

export default function Impressum(props) {
  const {
    logoSmallUrl,
    gmbhName,
    companyEmail,
    companyAddress,
    bioCertification,
    taxDetails,
    homePage,
    ...rest
  } = props;

  return (
    <div className={`impressum`}>
      <Logo className="contact__logo" logoSmallUrl={logoSmallUrl} />
      <div>
        {companyAddress.split("\n").map((i, key) => {
          return <div key={key}>{i}</div>;
        })}
      </div>

      <div>
        <a href={`mailto:${companyEmail}`}>{companyEmail}</a>
      </div>
      <div>
        <a rel="noreferrer" target="_blank" href={`https://${homePage}`}>
          {homePage}
        </a>
      </div>
      <p></p>
      <div>
        {bioCertification.split("\n").map((i, key) => {
          return <div key={key}>{i}</div>;
        })}
      </div>
      <div>
        {taxDetails.split("\n").map((i, key) => {
          return <div key={key}>{i}</div>;
        })}
      </div>
      <div>
        © copyright {new Date().getFullYear()} {gmbhName}
      </div>
    </div>
  );

  return (
    <div className={classNames("contact", className)} {...rest}>
      IMPRESSUM
      <p className="contact__text">
        <FormattedMessage id="contactForQuestions" />
      </p>
      <div className="contact__link">
        E-Mail:{" "}
        <a rel="noreferrer" target="_blank" href={`mailto:${companyEmail}`}>
          {companyEmail}
        </a>
      </div>
      <div className="contact__link">
        <FormattedMessage id="telephone" />:{" "}
        <a rel="noreferrer" target="_blank" href={`tel:${phoneNumber}`}>
          {phoneNumber}
        </a>
      </div>
    </div>
  );
}
